import { jsx } from 'react/jsx-runtime';
import { styled, TextareaAutosize } from '@mui/material';
import { forwardRef } from 'react';

/**
 *`TextArea` component which is based on MUI's TextareaAutosize and shares qualities of textarea element
 */
const TextArea = forwardRef(function TextAreaComponent(props, ref) {
    return jsx(TextAreaBase, Object.assign({}, props, { ref: ref }));
});
const TextAreaBase = styled(TextareaAutosize)(({ theme, resize = "none", readOnly, $isError, $isDisabled }) => (Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, theme.typography.body2), { alignItems: "center", background: theme.palette.ui12, border: `1px solid ${theme.palette.ui50}`, borderRadius: theme.shape.borderRadius, color: theme.palette.text.high, display: "flex", flexWrap: "nowrap", marginBottom: theme.spacing(1), padding: theme.spacing(1.5), resize, width: "100%", transition: `
      background-color 100ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      box-shadow 100ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      border-color 100ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      color 100ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      outline 100ms cubic-bezier(0.4, 0, 0.2, 1) 0ms
    `, "&:hover": {
        boxShadow: `0px 4px 4px rgba(32, 37, 43, 0.05)`,
    }, "&:focus-within": Object.assign({ outline: 0, borderColor: theme.palette.primary[800], boxShadow: `
        0 2px 2px rgba(26, 99, 171, 0.15),
        0 4px 8px rgba(32, 37, 43, 0.15)
      ` }, ($isError && {
        borderColor: theme.palette.failure[300],
        color: theme.palette.text.high,
        boxShadow: `
          0px 2px 2px rgba(219, 28, 28, 0.2),
          0px 4px 8px rgba(32, 37, 43, 0.2)
        `,
    })) }), ($isDisabled && {
    color: theme.palette.text.low,
    background: theme.palette.ui40,
    pointerEvents: "none",
    "&:hover": {
        boxShadow: "none",
    },
})), ($isError && {
    borderColor: theme.palette.failure[300],
    color: theme.palette.failure[300],
})), (readOnly && Object.assign(Object.assign({ color: theme.palette.text.high }, ($isError && {
    color: theme.palette.failure[300],
})), { pointerEvents: "none", "&:hover": {
        boxShadow: "none",
    }, "&:focus": Object.assign({ boxShadow: "none", borderColor: theme.palette.ui50 }, ($isError && {
        borderColor: theme.palette.failure[300],
        color: theme.palette.failure[300],
    })) })))));

export { TextArea };
//# sourceMappingURL=TextArea.js.map
